import { render, staticRenderFns } from "./DichiarazioneForm.vue?vue&type=template&id=33eff528&"
import script from "./DichiarazioneForm.vue?vue&type=script&lang=js&"
export * from "./DichiarazioneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DichiarazioneForm.vue"
export default component.exports